/**
 * [isUrlExternal] - determine if passed absolute url is external to the current domain.
 */
export const isUrlExternal = (url: string) => {
  return url.startsWith("http");
};

/**
 * Handles internal navigation clicks by preventing default browser behavior and
 * programmatically updating the URL and history state.
 *
 * @param e - The click event from the anchor element
 * @param to - The destination path to navigate to
 *
 * @remarks
 * - Converts relative paths to absolute by prepending "/" if needed
 * - Updates browser history using pushState and dispatches a popstate event
 */
export const handleInternalNavigation = (
  e: React.MouseEvent<HTMLAnchorElement>,
  to: string
) => {
  // Don't handle navigation if modifier keys are pressed
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
    return;
  }

  // Don't handle middle clicks or right clicks
  if (e.button && e.button !== 0) {
    return;
  }

  e.preventDefault();

  // Handle relative paths
  const resolvedPath = to.startsWith("/") ? to : `/${to}`;
  window.history.pushState({}, "", resolvedPath);
  window.dispatchEvent(new PopStateEvent("popstate"));
};
